var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLemonLime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1926,
    height: 40,
    viewBox: "0 0 1926 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_63422)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3580_63422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1926,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3580_63422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.71 67.1367C1844.95 123.118 1892.5 190.131 1926 264.806V-130.533C1892.52 -55.8377 1844.95 11.1554 1786.71 67.1367Z",
    fill: "url(#paint0_linear_3580_63422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.335 67.137C838.253 -1.17986 783.121 -85.9241 750.018 -180.998H362.291C416.72 -87.5487 447.937 21.1044 447.937 137.059C447.937 422.22 259.31 663.295 0.00195312 742.483V903.146H841.423C761.996 797.381 714.929 665.943 714.929 523.492C714.929 344.195 789.521 182.329 909.335 67.1571V67.137Z",
    fill: "url(#paint1_linear_3580_63422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.335 67.137C1023.13 -42.2382 1177.71 -109.472 1348.02 -109.472C1518.33 -109.472 1672.91 -42.2181 1786.71 67.137C1844.95 11.1557 1892.5 -55.8574 1926 -130.533V-180.998H750.019C783.122 -85.9241 838.273 -1.15979 909.335 67.137Z",
    fill: "url(#paint2_linear_3580_63422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.937 137.059C447.937 21.1044 416.72 -87.5287 362.291 -180.998H0.00195312V742.463C259.31 663.295 447.937 422.2 447.937 137.038V137.059Z",
    fill: "url(#paint3_linear_3580_63422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.335 67.137C1023.13 176.512 1177.71 243.746 1348.02 243.746C1518.33 243.746 1672.91 176.492 1786.71 67.137C1672.91 -42.2382 1518.33 -109.472 1348.02 -109.472C1177.71 -109.472 1023.13 -42.2182 909.335 67.137Z",
    fill: "url(#paint4_linear_3580_63422)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3580_63422",
    x1: 1926,
    y1: 569.781,
    x2: 1926,
    y2: -327.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#F1EB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#79BF5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3580_63422",
    x1: 1182.23,
    y1: 1006.24,
    x2: -811.845,
    y2: -207.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#F1EB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#79BF5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3580_63422",
    x1: 657.684,
    y1: -26.8396,
    x2: 2892.01,
    y2: -26.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#F1EB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#79BF5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3580_63422",
    x1: -459.478,
    y1: 280.48,
    x2: 581.605,
    y2: 280.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#F1EB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#79BF5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3580_63422",
    x1: 1186.23,
    y1: 321.523,
    x2: 1526.59,
    y2: -339.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#F1EB7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#79BF5D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_63422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonLime);
export default __webpack_public_path__ + "static/media/lemon-lime.16b668af74eec04864aef3f62b05eb5c.svg";
export { ForwardRef as ReactComponent };